var map = {
	"./Bienvenue-La-voie-de-la-bonne-voix.pdf": 1260,
	"./GB-academy-logo-white.png": 588,
	"./Introduction-La-voie-de-la-bonne voix.pdf": 1261,
	"./OpenMic.jpg": 206,
	"./aCES_8399.png": 1262,
	"./aCES_8523.png": 1263,
	"./aCES_8608.jpg": 589,
	"./aCES_8613.jpg": 542,
	"./choir.jpg": 207,
	"./choirmini.jpg": 590,
	"./concert.jpg": 545,
	"./concert2.jpg": 1264,
	"./contact_me.jpeg": 208,
	"./cour.jpg": 544,
	"./cour2.jpg": 1265,
	"./gaelle.jpeg": 1266,
	"./gaelleLogo.png": 541,
	"./gaelleLogoV2_Long_pour_fond_blanc.png": 1267,
	"./improve_speech.jpg": 1268,
	"./instruments.jpg": 591,
	"./kid.jpg": 543,
	"./learn_french_through_music.jpg": 1269,
	"./lesson.jpg": 309,
	"./live_music_online.jpg": 1270,
	"./mommyme1.jpg": 592,
	"./mommyme2.jpg": 593,
	"./mommyme3.jpg": 594,
	"./music_therapy_workshop.jpg": 1271,
	"./musical_training_toddler_parents.jpg": 1272,
	"./musicawareness.jpg": 310,
	"./musicotherapie.jpg": 595,
	"./musictherapybg.jpg": 311,
	"./partitions.jpeg": 209,
	"./price.png": 587,
	"./review.png": 596,
	"./serrage.jpg": 538,
	"./shop-logo.jpg": 597,
	"./shop.jpg": 598,
	"./shop1.jpg": 1273,
	"./showmini.jpg": 599,
	"./singing_class_routine.jpg": 1274,
	"./singing_lesson.jpg": 600,
	"./singing_page.jpg": 1275,
	"./stage.jpg": 210,
	"./student_show.jpg": 1276,
	"./vocal_audition_evaluation.jpg": 1277,
	"./voice_image_alignment.jpg": 1278,
	"./workshop.jpg": 1279
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1259;


//////////////////
// WEBPACK FOOTER
// ./src/images ^\.\/.*$
// module id = 1259
// module chunks = 0